import React from 'react';
import { LuFileText } from 'react-icons/lu';

import { useComplianceCentre } from '../context/ComplianceCentreContext';
import { fileUrl, formatDate } from '../complianceCentreUi';

export default function KeyDocuments() {
  const { data, setPanel, emptyMessage } = useComplianceCentre();
  const documents = (data?.documents || []).slice(0, 5).map(doc => ({ ...doc,
    title: doc.name, dateLabel: 'Recorded: ' + formatDate(doc.date), tagText: 'Saved', tagStyles: 'bg-emerald-50 text-emerald-700',
  }));

  return (
    <div className="w-full max-w-md bg-white rounded-2xl p-5 border border-gray-100 shadow-sm font-sans select-none">
      
      {/* Card Header Row */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-slate-900 font-extrabold text-base tracking-tight text-left">
          Key Documents
        </h3>
        <button type="button" onClick={() => setPanel("documents")} className="text-xs font-bold text-blue-600 hover:text-blue-700 transition">
          View all
        </button>
      </div>

      {/* Structured Content Rows List */}
      <div className="divide-y divide-gray-50">
        {!documents.length && <p className="py-5 text-xs text-slate-400">{emptyMessage('No supporting documents saved.')}</p>}
        {documents.map((doc) => (
          <a href={fileUrl(doc.url) || undefined} target="_blank" rel="noreferrer"
            key={doc.id} 
            className="py-3 flex items-center justify-between space-x-4 group hover:bg-slate-50/40 px-1 rounded-xl transition duration-150"
          >
            {/* Left Grouping: Document Icon & Content Texts */}
            <div className="flex items-center space-x-3.5 min-w-0">
              {/* Rounded background file icon container */}
              <div className="w-9 h-9 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm">
                <LuFileText className="w-4 h-4" />
              </div>
              
              {/* Labels Stack */}
              <div className="text-left min-w-0 space-y-0.5">
                <span className="block text-xs md:text-sm font-bold text-slate-900 truncate">
                  {doc.title}
                </span>
                <span className="block text-[11px] font-medium text-slate-400">
                  {doc.dateLabel}
                </span>
              </div>
            </div>

            {/* Right Side Status Badge Tag */}
            <div className="flex-shrink-0">
              <span className={`inline-block text-[10px] md:text-xs font-bold px-2.5 py-1 rounded-lg ${doc.tagStyles}`}>
                {doc.tagText}
              </span>
            </div>

          </a>
        ))}
      </div>

    </div>
  );
}
